<template>
  <div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="hasLotPaiementSelected"
            ></selecteur-action>
          </div>
          <form @submit.prevent="rechercheIntoChildren()"
                class="column is-5 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeLotPaiement.recherche')" type="search" icon="magnify"
                     v-model="critereRechercheLotPaiement.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.LOT_PAIEMENT.exporter"
            in-progress/>
        </div>
        <parametrage-table
          :referenceTable="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <div class="mgt-20px">
      <remise-bancaire-table v-if="startArrayRendering"
        :sens="constantes.SENS_ACHAT"
        :referenceTable="referenceTable"
        :permissions="permissions"
        :moduleDcf="moduleDcf"
        :nameStore="nameStore"
        :ref="referenceTable">
      </remise-bancaire-table>
    </div>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-lot-paiement ref="filtreLotPaiement"
        :nameStore="nameStore"
        :moduleDcf="moduleDcf"
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter"/>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import remiseBancaireTable from '@/components/remiseBancaire/listeRemiseBancaire/remiseBancaireTable';
import { SENS_ACHAT } from '@/configuration/devisConf';
import selecteurAction from '@/components/general/selecteurAction';
import { LOT_PAIEMENT } from '@/configuration/baux/permissionsBauxConf';
import filtreLotPaiement from '@/components/lotPaiement/filtreLotPaiement';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import parametrageTable from '@/components/general/parametrageTable';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    referenceTable: {
      type: String,
      required: true,
    },
    permissions: {
      type: Object,
      required: true,
    },
    moduleDcf: {
      type: String,
      required: true,
    },
    nameStore: {
      type: String,
      required: true,
    },
  },
  components: {
    remiseBancaireTable,
    selecteurAction,
    filtreLotPaiement,
    exportExcelButton,
    parametrageTable,
  },
  data() {
    return {
      actions: [],
      showFiltre: false,
      unsubscribeValue: null,
      constantes: {
        SENS_ACHAT,
        LOT_PAIEMENT,
      },
      startArrayRendering: false,
    };
  },
  computed: {
    ...Societe.mapGetters({
      lockMenu: 'lockMenu',
    }),
    critereRechercheLotPaiement() {
      return this.$store.getters[`${this.nameStore}/critereRechercheLotPaiement`];
    },
    lotsPaiement() {
      return this.$store.getters[`${this.nameStore}/items`];
    },
    hasLotPaiementSelected() {
      return this.lotsPaiement.filter((remiseBancaire) => {
        return remiseBancaire.selected === true;
      }).length > 0;
    },
    nombreCritere() {
      let nbCritere = calculNombreCritere(this.critereRechercheLotPaiement, ['auto', 'exporteeEnCompta', 'sens',
        'datesRemise', 'module', 'societeId']);
      if (this.critereRechercheLotPaiement.exporteeEnCompta !== null) nbCritere += 1;
      if (this.critereRechercheLotPaiement.datesRemise
        && (this.critereRechercheLotPaiement.datesRemise.dateDebut
        || this.critereRechercheLotPaiement.datesRemise.dateFin)) {
        nbCritere += 1;
      }
      return nbCritere > 9 ? '+9' : nbCritere;
    },
  },
  methods: {
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreLotPaiement.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreLotPaiement.initializeFiltre();
      this.$refs.filtreLotPaiement.viderCritere();
      this.$refs.filtreLotPaiement.appliquerCritere();
      this.showFiltre = false;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.rechercheIntoChildren();
    },
    handleAction(action) {
      return action;
    },
    rechercheIntoChildren() {
      this.$refs[this.referenceTable].recherche();
    },
    goFirstPageIntoChildren() {
      this.$refs[this.referenceTable].goFirstPage();
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  created() {
    if (this.$route.params.idsLots) {
      this.critereRechercheLotPaiement.id = [...new Set(JSON.parse(this.$route.params.idsLots))];
    }
  },
  async mounted() {
    this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.rechercheIntoChildren, this.goFirstPageIntoChildren);
  },
};
</script>
